// Função para verificar se o storage está disponível
function isStorageAvailable() {
  try {
    const test = '__storage_test__';
    window.localStorage.setItem(test, test);
    window.localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

export const safeStorage = {
  getItem(key) {
    try {
      return isStorageAvailable() ? localStorage.getItem(key) : null;
    } catch (e) {
      console.warn('localStorage.getItem falhou:', e);
      return null;
    }
  },
  setItem(key, value) {
    try {
      if (isStorageAvailable()) {
        localStorage.setItem(key, value);
        return true;
      }
      return false;
    } catch (e) {
      console.warn('localStorage.setItem falhou:', e);
      return false;
    }
  },
  removeItem(key) {
    try {
      if (isStorageAvailable()) {
        localStorage.removeItem(key);
        return true;
      }
      return false;
    } catch (e) {
      console.warn('localStorage.removeItem falhou:', e);
      return false;
    }
  }
};
